import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';

const SignYourForms = ({ children }) => (
    <Timeline
        heading="sign your forms"
        icon={
            <FontAwesome
                className="primary-yellow con md image_center icon15"
                name="pencil"
                datacy="pencil"
                size="2x"
            />
        }>
        Your agent will send any paperwork that needs your signature. This will come separately from
        your new policy, either by email or in the mail. Please return them as soon as you can.
        <br />
        <br />
        {children}
    </Timeline>
);

export default SignYourForms;



// WEBPACK FOOTER //
// ./src/containers/SignYourForms/SignYourForms.jsx